import { ScoreType } from '../../../../../../store/admin/eventFormats/store';
import { IMetaFormat } from '../../../../../../store/admin/roundFormats/store';
import { IStateDispatchActions } from '../ContestSetup.context';
import { getContestSelectorOptions } from '../Utils/getContestSelectorOptions';

export interface IContestSelectorOption {
  label: string;
  value: {
    metaFormat: IMetaFormat;
    scoreType: ScoreType;
  };
}

export type ISetContestSelectorOptions = (roundFormats: IMetaFormat[]) => void;

export const setContestSelectorOptions: IStateDispatchActions<ISetContestSelectorOptions> = (
  _,
  dispatch
) => roundFormats => {
  const contestSelectorOptions = getContestSelectorOptions(roundFormats);

  dispatch({
    type: 'setContestSelectorOptions',
    value: contestSelectorOptions
  });

  const {
    value: { scoreType, metaFormat }
  } = contestSelectorOptions[0];

  dispatch({
    type: 'selectFormat',
    value: { scoreType, metaFormat }
  });
};
